import { getStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";

export default function getCategoryForCategorySortByRowKey(mailboxInfo: MailboxInfo, rowKey: string): string {
    return getStore(mailboxInfo).categoryByRowKey.get(rowKey) ?? "";
}
